namespace TabAurous.Retail {
    export interface GiftVoucherIssueRow {
        TransId?: number;
        VoucherTypeId?: number;
        VoucherNo?: string;
        TransDate?: string;
        GiftMasterId?: number;
        Quantity?: number;
        ItemDetails?: GiftVoucherItemDetailsRow[];
    }

    export namespace GiftVoucherIssueRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Retail.GiftVoucherIssue';
        export const deletePermission = 'Retail:GiftVoucherIssue:Delete';
        export const insertPermission = 'Retail:GiftVoucherIssue:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:GiftVoucherIssue:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate",
            GiftMasterId = "GiftMasterId",
            Quantity = "Quantity",
            ItemDetails = "ItemDetails"
        }
    }
}
